import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/index.vue'
import Brands from './views/Brands/index.vue'
import BrandsID from './views/Brands/_brand.vue'
import Catalog from './views/Catalog/index.vue'
import CategoryID from './views/Catalog/_category.vue'
import ProductID from './views/Catalog/_product.vue'
import Cart from './views/Cart/index.vue'
import SignIn from './views/SignIn.vue'
import SignUpRetailer from './views/SignUp/Retailer.vue'
import SignUpSupplier from './views/SignUp/Supplier.vue'
// import Retailer from './views/Retailer/index.vue'
// import RetailerCatalog from './views/Retailer/Catalog/index.vue'
import RetailerCatalogProductID from './views/Retailer/Catalog/_product/index.vue'
import RetailerBrands from './views/Retailer/Brands/index.vue'
import RetailerBrandsID from './views/Retailer/Brands/_brand.vue'
import RetailerList from './views/Retailer/Lists/index.vue'
import RetailerListID from './views/Retailer/Lists/_list.vue'
import RetailerCart from './views/Retailer/Cart/index.vue'
import RetailerOrders from './views/Retailer/Orders/index.vue'
import RetailerOrdersID from './views/Retailer/Orders/_order.vue'
import RetailerSettings from './views/Retailer/Settings.vue'
import Supplier from './views/Supplier/Dashboard.vue'
import SupplierGlobalStatistics from './views/Supplier/Statistics/GlobalStatistics.vue'
import SupplierGlobalSuppliers from './views/Supplier/Statistics/GlobalSuppliers.vue'
import SupplierGlobalBrands from './views/Supplier/Statistics/GlobalBrands.vue'
import SupplierGlobalRetailers from './views/Supplier/Statistics/GlobalRetailers.vue'
import SupplierGlobalRetailersDocs from './views/Supplier/Statistics/GlobalRetailersDocs.vue'
import SupplierProducts from './views/Supplier/Products/index.vue'
import SupplierProductsAdd from './views/Supplier/Products/Add.vue'
import SupplierProductsEdit from './views/Supplier/Products/_edit.vue'
import SupplierProductsEditSpecifications from './components/Cabinet/Supplier/Product/EditSpecification.vue'
import SupplierProductsEditInserts from './components/Cabinet/Supplier/Product/EditInserts.vue'
import SupplierProductsEditImages from './components/Cabinet/Supplier/Product/EditImagesForm.vue'
import SupplierProductsEditVisibility from './components/Cabinet/Supplier/Product/EditVisibility.vue'
import SupplierProductsDetail from './views/Supplier/Products/Detail.vue'
import SupplierSettings from './views/Supplier/Settings.vue'
import SupplierOrders from './views/Supplier/Orders/index.vue'
import SupplierOrder from './views/Supplier/Orders/_order.vue'
// import PublicHome from './views/Public/index.vue'
// import PublicCart from './views/Public/Cart/index.vue'
// import PublicBrands from './views/Public/Brands/index.vue'
// import PublicBrandsID from './views/Public/Brands/_brand.vue'
// import PublicCatalog from './views/Public/Catalog/index.vue'
// import PublicCategoryID from './views/Public/Catalog/_category.vue'
// import PublicProductID from './views/Public/Catalog/_product.vue'

import settings from '@/settings'

function getActualComponent(retailer, supplier) {
    switch (settings.TYPE) {
        case 'retailer':
            return retailer
        case 'supplier':
            return supplier
    }
}

function getActualName() {
    switch (settings.TYPE) {
        case 'retailer':
            return 'retailer'
        case 'supplier':
            return 'supplier'
    }
}

// function getActualLayout() {
//     switch (settings.TYPE) {
//         case 'supplier':
//         case 'retailer':
//             return { layout: 'cabinet' }
//         case 'guest':
//             return { layout: 'default' }
//     }
// }

Vue.use(Router)

export default new Router({
    linkActiveClass: 'active',
    linkExactActiveClass: 'active',
    mode: 'history',
    base: process.env.VUE_APP_BASE_URL,
    scrollBehavior() {
        return { x: 0, y: 0 }
    },
    routes: [
        // Public
        {
            path: '/',
            name: 'Home',
            component: Home,
            meta: { layout: 'default' }
        },
        {
            path: '/catalog/category/:id',
            name: 'CategoryID',
            component: CategoryID,
            props: true,
            alias: '/catalog/category/all',
            meta: { layout: 'default' }
        },
        {
            path: '/catalog/product/:id',
            name: 'ProductID',
            component: ProductID,
            meta: { layout: 'default' }
        },
        {
            path: '/brands',
            name: 'Brands',
            component: Brands,
            meta: { layout: 'default' }
        },
        {
            path: '/brands/:id',
            name: 'BrandsID',
            component: BrandsID,
            meta: { layout: 'default' }
        },
        {
            path: '/catalog',
            name: 'Catalog',
            component: Catalog,
            meta: { layout: 'default' }
        },
        {
            path: '/cart',
            name: 'Cart',
            component: Cart,
            meta: { layout: 'default' }
        },
        // Auth
        {
            path: '/sign-in',
            name: 'SignIn',
            component: SignIn,
            meta: { layout: 'blank' }
        },
        {
            path: '/sign-up-retailer',
            name: 'SignUpRetailer',
            component: SignUpRetailer,
            meta: { layout: 'blank' }
        },
        {
            path: '/sign-up-supplier',
            name: 'SignUpSupplier',
            component: SignUpSupplier,
            meta: { layout: 'blank' }
        },
        // Retailer or Supplier
        {
            path: '/account',
            name: getActualName() + 'Home',
            component: getActualComponent(Home, Supplier),
            meta: { layout: 'cabinet' }
        },
        {
            path: '/account/orders',
            name: getActualName() + 'Orders',
            component: getActualComponent(RetailerOrders, SupplierOrders),
            meta: { layout: 'cabinet' }
        },
        {
            path: '/account/orders/:id',
            name: getActualName() + 'OrdersID',
            component: getActualComponent(RetailerOrdersID, SupplierOrder),
            meta: { layout: 'cabinet' }
        },
        {
            path: '/account/settings',
            name: getActualName() + 'Settings',
            component: getActualComponent(RetailerSettings, SupplierSettings),
            meta: { layout: 'cabinet' }
        },
        // Retailer
        {
            path: '/account/catalog/category/:id',
            name: 'RetailerCategoryID',
            component: CategoryID,
            props: true,
            alias: '/account/catalog/category/all',
            meta: { layout: 'cabinet' }
        },
        {
            path: '/account/catalog/product/:id',
            name: 'RetailerProductID',
            component: RetailerCatalogProductID,
            meta: { layout: 'cabinet' }
        },
        {
            path: '/account/brands',
            name: 'RetailerBrands',
            component: RetailerBrands,
            meta: { layout: 'cabinet' }
        },
        {
            path: '/account/brands/:id',
            name: 'RetailerBrandsID',
            component: RetailerBrandsID,
            meta: { layout: 'cabinet' }
        },
        {
            path: '/account/catalog',
            name: 'RetailerCatalog',
            component: Catalog,
            meta: { layout: 'cabinet' }
        },
        {
            path: '/account/cart',
            name: 'RetailerCart',
            component: RetailerCart,
            meta: { layout: 'cabinet' }
        },
        {
            path: '/account/lists',
            name: 'RetailerList',
            component: RetailerList,
            meta: { layout: 'cabinet' }
        },
        {
            path: '/account/lists/:id',
            name: 'RetailerListID',
            component: RetailerListID,
            meta: { layout: 'cabinet' }
        },
        // {
        //     path: '/retailer',
        //     name: 'Retailer',
        //     component: Retailer,
        //     meta: { layout: 'cabinet' }
        // },
        // {
        //     path: '/retailer/catalog',
        //     name: 'RetailerCatalog',
        //     component: RetailerCatalog,
        //     meta: { layout: 'cabinet' }
        // },
        // {
        //     path: '/retailer/catalog/product/:id',
        //     name: 'RetailerCatalogProductID',
        //     component: RetailerCatalogProductID,
        //     meta: { layout: 'cabinet' }
        // },
        // {
        //     path: '/retailer/brands',
        //     name: 'RetailerBrands',
        //     component: RetailerBrands,
        //     meta: { layout: 'cabinet' }
        // },
        // {
        //     path: '/retailer/brands/:id',
        //     name: 'RetailerBrandsID',
        //     component: RetailerBrandsID,
        //     meta: { layout: 'cabinet' }
        // },
        // {
        //     path: '/cart',
        //     name: 'RetailerCart',
        //     component: RetailerCart,
        //     meta: { layout: 'cabinet' }
        // },
        // Supplier
        // {
        //     path: '/supplier',
        //     name: 'Supplier',
        //     component: Supplier,
        //     meta: { layout: 'cabinet' }
        // },
        {
            path: '/account/statistics',
            name: 'SupplierGlobalStatistics',
            component: SupplierGlobalStatistics,
            meta: { layout: 'cabinet' }
        },
        {
            path: '/account/statistics/suppliers',
            name: 'SupplierGlobalSuppliers',
            component: SupplierGlobalSuppliers,
            meta: { layout: 'cabinet' }
        },
        {
            path: '/account/statistics/brands',
            name: 'SupplierGlobalBrands',
            component: SupplierGlobalBrands,
            meta: { layout: 'cabinet' }
        },
        {
            path: '/account/statistics/retailers',
            name: 'SupplierGlobalRetailers',
            component: SupplierGlobalRetailers,
            meta: { layout: 'cabinet' }
        },
        {
            path: '/account/statistics/retailers/:id/docs',
            name: 'SupplierGlobalRetailersDocs',
            component: SupplierGlobalRetailersDocs,
            meta: { layout: 'cabinet' }
        },
        {
            path: '/account/products',
            name: 'SupplierProducts',
            component: SupplierProducts,
            meta: { layout: 'cabinet' }
        },
        {
            path: '/account/products-add',
            name: 'SupplierProductsAdd',
            component: SupplierProductsAdd,
            meta: { layout: 'cabinet' }
        },
        {
            path: '/account/products/:id',
            name: 'SupplierProductsEdit',
            component: SupplierProductsEdit,
            children: [
                {
                    path: 'specifications',
                    name: 'SupplierProductsEditSpecifications',
                    component: SupplierProductsEditSpecifications,
                    meta: { layout: 'cabinet' }
                },
                {
                    path: 'inserts',
                    name: 'SupplierProductsEditInserts',
                    component: SupplierProductsEditInserts,
                    meta: { layout: 'cabinet' }
                },
                {
                    path: 'images',
                    name: 'SupplierProductsEditImages',
                    component: SupplierProductsEditImages,
                    meta: { layout: 'cabinet' }
                },
                {
                    path: 'access',
                    name: 'SupplierProductsEditVisibility',
                    component: SupplierProductsEditVisibility,
                    meta: { layout: 'cabinet' }
                }
            ],
            meta: { layout: 'cabinet' }
        },
        {
            path: '/account/products/:id/detail',
            name: 'SupplierProductsDetail',
            component: SupplierProductsDetail,
            meta: { layout: 'cabinet' }
        }
        // {
        //     path: '/supplier/settings',
        //     name: 'SupplierSettings',
        //     component: SupplierSettings,
        //     meta: { layout: 'cabinet' }
        // },
        // {
        //     path: '/supplier/orders',
        //     name: 'SupplierOrders',
        //     component: SupplierOrders,
        //     meta: { layout: 'cabinet' }
        // },
        // {
        //     path: '/supplier/orders/:id',
        //     name: 'SupplierOrder',
        //     component: SupplierOrder,
        //     meta: { layout: 'cabinet' }
        // }
        // {
        //     path: '/public',
        //     name: 'PublicHome',
        //     component: PublicHome,
        //     meta: { layout: 'public' }
        // },
        // {
        //     path: '/public/cart',
        //     name: 'PublicCart',
        //     component: PublicCart,
        //     meta: { layout: 'public' }
        // },
        // {
        //     path: '/public/brands',
        //     name: 'PublicBrands',
        //     component: PublicBrands,
        //     meta: { layout: 'public' }
        // },
        // {
        //     path: '/public/brands/:id',
        //     name: 'PublicBrandsID',
        //     component: PublicBrandsID,
        //     meta: { layout: 'public' }
        // },
        // {
        //     path: '/public/catalog',
        //     name: 'PublicCatalog',
        //     component: PublicCatalog,
        //     meta: { layout: 'public' }
        // },
        // {
        //     path: '/public/catalog/category/:id',
        //     name: 'PublicCategoryID',
        //     component: PublicCategoryID,
        //     meta: { layout: 'public' },
        //     props: true,
        //     alias: '/public/catalog/category/all'
        // },
        // {
        //     path: '/public/catalog/product/:id',
        //     name: 'PublicProductID',
        //     component: PublicProductID,
        //     meta: { layout: 'public' }
        // }
    ]
})
